import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';

import { insertUpdateItems } from '../../../../../../common/reducers/listsCollection/reducer';
import { insertUpdateItems as insertUpdateObjectCollectionItems } from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/TasksExecsService';

function* execsListAuthUserByTask(reducerName, action) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsService.getTasksExecsAuthUserByTask,
      action.payload,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status === 200) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.tasksById,
            itemsIds: result.destructData.tasksIds,
            pagination: result.destructData.pagination
          })
        );
        yield put(
          insertUpdateItems(
            'tasksModule.collections.tasksExecsNotSendMaterialsCollection',
            {
              itemsById: result.destructData.noSendExecMaterials,
              groupMapItemsIds: result.destructData.noSendExecMaterialsMapByExec
            }
          )
        );
        yield put(
          insertUpdateItems('tasksModule.collections.tasksExecLogCollection', {
            itemsById: result.destructData.execLogs,
            groupMapItemsIds: result.destructData.execLogsMapByExec
          })
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'tasksModule.collections.tasksExecsCollection',
            result.destructData.tasksById
          )
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      execsListAuthUserByTask,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/lists/sagas/execsListAuthUserByTaskSaga.js